module.exports = __webpack_public_path__ + "static/media/support.165d2ac4.svg";